/**
 * Created by LENOVO T440 on 08/04/2016.
 */

(function(){
    angular.module('app.widgets')
        .directive('obtUploadChange', obtChangeFn);

    obtChangeFn.$inject=[];
    function obtChangeFn(){
        return {
            restrict:'E',
            scope:{
                form:'=?',
                item:'=?',
                ngChange :'&',
                uploadData:'=?',
                placeholder:'@?'
            },
            template:'<div class="thumbnail" >\n  <img ng-if="vm.item && !vm.url" class="thumbnailSize"  ng-src="{{\'./\' + vm.item}}" />\n   <img ng-if="vm.item && vm.url" class="thumbnailSize"  ng-src="{{vm.item}}" />  \n     <img ng-if="!vm.item" class="thumbnailSize" ng-src="{{vm.placeholder ? vm.placeholder : \'./img/default_avatar.png\'}}" /></div> \n<div class="btn btn-primary btn-upload"\n     upload-button\n     accept="image/*"\n     data="vm.uploadData"\n     url="./php/simpleUpload.php"\n     on-success="vm.onUploadSuccess(response)"\n        >{{\'UPLOAD\'|translate}}</div>&nbsp;<div class="btn btn-danger "\n        ng-click="vm.deleteImage()"\n        >{{\'DELETE_IMAGE\'|translate}}</div> <br/><br/>  <div><input class="col-md-12" type="text" ng-model="vm.newItem"/></div>\n <br/><br/> <div class="btn btn-primary "  ng-click="vm.urlImage(vm.newItem)"\n        >{{\'url_IMAGE\'|translate}}</div>',
            controller: ctrlFn2,
            controllerAs:'vm',
            bindToController:true
        };
    }
    ctrlFn2.$inject=['$scope','uploadService'];
    function ctrlFn2($scope,uploadService){
        var vm = this;
         init();
        function init (){
         if(vm.item){
             var test =  vm.item.indexOf('cData');
             var test1 =  vm.item.indexOf('upload');
             if(test !== -1 || test1 !== -1){
                 vm.url= true;
             }
             else{
                 vm.url= false;
             }
         }
        }
        vm.onUploadSuccess = onUploadSuccess;
        vm.deleteImage = deleteImage;
        vm.urlImage = urlImage;

        function onUploadSuccess (response){
            uploadService.broadcast(uploadService.CHANNEL.UPLOAD_DATA_CHANGED,'changed');
            console.log(response);
            vm.url= false;
            vm.item = response.data.path;
            if(vm.form){
                vm.form.$pristine = false;
            }
        }
        function deleteImage (){
            vm.item = '';
            if(vm.form){
                vm.form.$pristine = false;
            }

        }

        function urlImage (data){
           if(data !==null || data !== undefined){
               console.log('data',data);
               vm.url= true;
               vm.item = data;
               console.log('item',vm.item);
             //  vm.newItem = null;
               if(vm.form){
                   vm.form.$pristine = false;
               }
           }

        }
    }
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/uploadImageChange.js
 ** module id = 201
 ** module chunks = 0
 **/